export default __webpack_public_path__ + "static/media/citySpark-price-5000-will-jamous-ShortArrow.0ea19b6a.webp";